import {
  array,
  boolean,
  type BaseActionDefinition,
  defineAction,
  number,
  object,
  string,
} from '~/prix'

export const geoSyncFetchInputShape = {
  ids: array(string()).isOptional(),
  countryId: number().isOptional(),
  macroRegionId: number().isOptional(),
  stateId: number().isOptional(),
  mesoRegionId: number().isOptional(),
  microRegionId: number().isOptional(),
  municipalityId: number().isOptional(),
  districtId: number().isOptional(),
  neighborhoodId: number().isOptional(),
  suburbId: number().isOptional(),
  streetId: number().isOptional(),
  buildingId: number().isOptional(),
  postalCodeId: number().isOptional(),
  stateRoadId: number().isOptional(),
  limit: number().isOptional(),
  offset: number().isOptional(),
  includeDeleted: boolean().isOptional(),
  updatedAfter: string().isOptional(),
}

const geoSyncFetchOutput = object<any>({})

export default function defineGeoSyncFetchAction<ActionJson extends BaseActionDefinition>(
  actionJson: ActionJson,
  additionalInputShape: Record<string, any> = {},
) {
  return defineAction({
    ...actionJson,
    input: object({
      ...geoSyncFetchInputShape,
      ...additionalInputShape,
    }),
    output: geoSyncFetchOutput,
  })
}
